import "./Cookies.module.css";
import Header from "@/reusable_sections/Header";
import Informasjonskapsler from "./sections/Informasjonskapsler";
import Footer from "@/reusable_sections/Footer";
export default function CookiesPage() {
  return <div>
      <Header />
      <Informasjonskapsler />
      <Footer />
    </div>;
}